
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offices/[slug]",
      function () {
        return require("private-next-pages/offices/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offices/[slug]"])
      });
    }
  